import { render, staticRenderFns } from "./VehicleRequest.vue?vue&type=template&id=5d2be0e6&"
import script from "./VehicleRequest.vue?vue&type=script&lang=js&"
export * from "./VehicleRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports